import React, { useState, useEffect } from "react";
import apiClient from "../api/apiClient";

const Carrieres = () => {
  // États pour chacune des routes
  const [carrieres, setCarrieres] = useState([]);
  const [avantages, setAvantages] = useState([]);
  const [pageCarriere, setPageCarriere] = useState(null);
  const [etapes, setEtapes] = useState([]);
  const [offres, setOffres] = useState([]);
  const [photos, setPhotos] = useState([]);
  // État pour savoir si la page est encore en train de charger
  const [isLoading, setIsLoading] = useState(true);
  // Optionnel : candidatures
  // const [candidatures, setCandidatures] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // Récupérer les carrières
        const carrieresResponse = await apiClient.get(
          `${process.env.REACT_APP_API_URL}/carrieres`,
        );
        setCarrieres(carrieresResponse.data);
      } catch (error) {}

      try {
        // Récupérer les avantages employés
        const avantagesResponse = await apiClient.get(
          `${process.env.REACT_APP_API_URL}/avantages_employes`,
        );
        setAvantages(avantagesResponse.data);
      } catch (error) {}

      try {
        // Récupérer la page carrière (ici on suppose qu'il y a un seul enregistrement)
        const pageResponse = await apiClient.get(
          `${process.env.REACT_APP_API_URL}/page_carriere`,
        );
        setPageCarriere(pageResponse.data[0]);
      } catch (error) {}

      try {
        // Récupérer les étapes d'entretien
        const etapesResponse = await apiClient.get(
          `${process.env.REACT_APP_API_URL}/etapes_entretien`,
        );
        setEtapes(etapesResponse.data);
      } catch (error) {}

      try {
        // Récupérer les offres d'emploi
        const offresResponse = await apiClient.get(
          `${process.env.REACT_APP_API_URL}/offres_emploi`,
        );
        setOffres(offresResponse.data);
      } catch (error) {}

      try {
        // Récupérer les photos d'entreprise
        const photosResponse = await apiClient.get(
          `${process.env.REACT_APP_API_URL}/photos_entreprise`,
        );
        setPhotos(photosResponse.data);
      } catch (error) {}
    };

    fetchAll();
  }, []);

  {
    /* Loader : on l’affiche tant que isLoading === true */
  }
  {
    isLoading && (
      <div className="onloadpage" id="page-load">
        <div className="loader-div">
          <div className="on-img">
            {/* Votre GIF loader.gif */}
            <img
              src="images/loader.gif"
              alt="Loading..."
              className="img-fluid"
              style={{ width: "80px", height: "80px" }} // ajustez si besoin
            />
            <span style={{ marginTop: "0.5rem" }}>Loading Please Wait...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Section Header : Carrières */}
      <div className="port-head-sec pt85 pb120 r-bg-x">
        {carrieres.map((carriere) => (
          <div className="container" key={carriere.id_carriere}>
            <div className="row vcenter pt80">
              <div className="col-lg-6">
                <div className="page-headings">
                  <span
                    className="sub-heading mb15"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <i className="fas fa-briefcase mr5"></i>{" "}
                    {carriere.titre_carriere}
                  </span>
                  {carriere.sous_titre && (
                    <h3
                      classNam
                      e="mb15"
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      {carriere.sous_titre}
                    </h3>
                  )}
                  <p
                    className="h-light"
                    data-aos="fade-up"
                    data-aos-delay="600"
                  >
                    {carriere.description_carriere}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="sol-img m-mt30"
                  data-aos="fade-in"
                  data-aos-delay="400"
                >
                  <img
                    src={carriere.image_path || "images/portfolio/default.jpg"}
                    alt={carriere.titre_carriere}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Section Page Carrière */}
      {/* <section className="page-carriere-sec sec-pad">
         <div className="container">
           <div className="row justify-content-center">
             <div className="col-lg-12 text-center">
               <div className="page-headings">
                 <h2 className="mb15">{pageCarriere.titre}</h2>
                 <h4 className="mb15">{pageCarriere.sous_titre}</h4>
                 <p>{pageCarriere.description}</p>
               </div>
             </div>
           </div>
         </div>
      </section> */}

      {/* Section Avantages employés */}
      <section className="avantages-sec sec-pad r-bg-a">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="page-headings">
                <h2 className="mb15">Nos avantages</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt30">
            {avantages.length ? (
              avantages.map((avantage) => (
                <div
                  className="col-lg-3 col-md-6 col-sm-6 mt30"
                  key={avantage.id}
                >
                  <div className="process-content ree-card">
                    <div className="process-block">
                      <div className="process-icon">
                        <img
                          src={
                            avantage.icone_path ||
                            "images/portfolio/default.jpg"
                          }
                          alt={avantage.titre}
                          className="icon70 mb15"
                        />
                      </div>
                      <h4>{avantage.titre}</h4>
                      <p>{avantage.description}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Aucun avantage à afficher.</p>
            )}
          </div>
        </div>
      </section>

      {/* Section La vie chez Reevan (Photos d'entreprise) */}
      <section className="r-bg-x sec-pad">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="page-headings">
                <h2 className="mb15">
                  La vie chez{" "}
                  <span className="ree-text rt40">DVEKGE GROUP</span>
                </h2>
                <p>
                  Découvrez notre univers à travers les photos de notre
                  entreprise.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt30">
            {photos.length ? (
              photos.map((photo) => (
                <div
                  className={`col-lg-${photo.largeur || 4} col-md-6 mt30`}
                  key={photo.id}
                >
                  <div className="hovr-scale-main">
                    <div className="portfolio-flimg hovr-scale-base">
                      <a href="#">
                        <img
                          src={`${process.env.REACT_APP_API_URL}/uploads/${photo.image}`}
                          alt={photo.titre}
                          className="w-100"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Aucune photo à afficher.</p>
            )}
          </div>
        </div>
      </section>

      {/* Section Processus d'entretien */}
      <section className="r-bg-d sec-pad">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="page-headings">
                <h2 className="mb15">
                  Processus d'<span className="ree-text rt40">Entretien</span>
                </h2>
                <p>
                  Découvrez notre processus de recrutement en plusieurs étapes.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt30">
            {etapes.length ? (
              etapes.map((etape) => (
                <div className="col-lg-3 col-md-6 col-sm-6 mt30" key={etape.id}>
                  <div className="process-content ree-card">
                    <div className="process-block">
                      <div className="process-icon">
                        <img
                          src={`${process.env.REACT_APP_API_URL}/uploads/${etape.icone}`}
                          alt={etape.titre}
                          className="icon70 mb15"
                        />
                      </div>
                      <h4>{etape.titre}</h4>
                      <p>{etape.description}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Aucune étape d'entretien à afficher.</p>
            )}
          </div>
        </div>
      </section>

      {/* Section Offres d'emploi */}
      <section className="home-partners-block r-bg-a sec-pad" id="job">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="sec-heading text-center">
                <h2 className="mb15">
                  Nous <span className="ree-text rt40">Recrutons!</span>
                </h2>
                <p>
                  Découvrez nos offres d'emploi actuelles et rejoignez notre
                  équipe.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt30">
            {offres.length ? (
              offres.map((offre) => (
                <div className="col-lg-4 mt30" key={offre.id}>
                  <div className="job-detail ree-card">
                    <h4>{offre.titre}</h4>
                    <div className="job-info w-100 mt30">
                      <div className="career-detail">
                        <p>Expérience Requise</p>
                        <p>{offre.experience_requise}</p>
                      </div>
                      <div className="career-detail">
                        <p>Nombre de Postes</p>
                        <p>{offre.nombre_postes}</p>
                      </div>
                      <div className="career-detail">
                        <p>Lieu de Travail</p>
                        <p>{offre.lieu}</p>
                      </div>
                      <div className="career-detail">
                        <p>Type d'Emploi</p>
                        <p>{offre.type_emploi}</p>
                      </div>
                    </div>
                    <div className="job-titl mt40">
                      <p>
                        Publié le{" "}
                        {new Date(offre.date_publication).toLocaleDateString()}
                      </p>
                      <a href="/candidature" className="ree-btn ree-btn-grdt2">
                        Postuler <i className="fas fa-arrow-right fa-btn"></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Aucune offre d'emploi disponible pour le moment.</p>
            )}
          </div>
        </div>
      </section>

      {/* Section Candidatures (optionnelle) */}
      {/*
      <section className="candidatures-sec sec-pad r-bg-x">
         <div className="container">
           <div className="row justify-content-center">
             <div className="col-lg-12 text-center">
               <div className="page-headings">
                 <h2 className="mb15">Candidatures</h2>
               </div>
             </div>
           </div>
           <div className="row justify-content-center mt30">
             {candidatures.length ? (
               candidatures.map(candidature => (
                 <div className="col-lg-4 mt30" key={candidature.id}>
                   <div className="job-detail ree-card">
                     <h4>{candidature.nom} {candidature.prenom}</h4>
                     <p>Email : {candidature.email}</p>
                     <p>Téléphone : {candidature.telephone}</p>
                     <p>Statut : {candidature.statut}</p>
                     <p>Date : {new Date(candidature.date_candidature).toLocaleDateString()}</p>
                   </div>
                 </div>
               ))
             ) : (
               <p>Aucune candidature à afficher.</p>
             )}
           </div>
         </div>
      </section>
      */}
    </div>
  );
};

export default Carrieres;
